export default "__VITE_ASSET__3bd6cb82__"